<template>
  <div>
    <ReflectionAnalysisCard
      v-for="doc in analyses"
      :key="doc.id"
      :analysis="doc"
      :reflection-id="reflectionId"
      @insert-block="insertBlock"
      @insert-supporting-doc="insertSupportingDoc"
    />
    <p v-if="analyses.length == 0" class="text-center pt-10 noAnalysis">
      {{ $t('views.reflection.noAnalysisInReflection') }}
    </p>
  </div>
</template>
<script>
import ReflectionAnalysisCard from './ReflectionAnalyses/ReflectionAnalysisCard';

export default {
  name: 'ReflectionAnalyses',
  components: {
    ReflectionAnalysisCard,
  },
  props: {
    analyses: {
      type: Array,
      required: true,
    },
    reflectionId: {
      type: String,
      required: true,
    },
  },
  methods: {
    insertBlock(blockData) {
      this.$emit('insert-block', blockData);
    },
    insertSupportingDoc(analysisId) {
      this.$emit('insert-supporting-doc', analysisId);
    },
  },
};
</script>
<style scoped>
.noAnalysis {
  color: #999;
}
</style>
